export enum EdgeThickness {
    twoCM = '2CM',
    threeCM = '3CM',
}
